import axios from '../axios'

// 登录
export const login = data => {
    return axios({
        url: '/api/user/login',
        method: 'post',
        data
    })
}

// 发送短信验证码
export const sendSmsVerifyCode = data => {
    return axios({
        url: '/api/sms/verify/code/sendCode',
        method: 'post',
        data
    })
}

// 登出
export const logout = data => {
    return axios({
        url: '/api/user/logout',
        method: 'post',
        data
    })
}

// 获取图形验证码
export const captcha = data => {
    return axios({
        url: '/api/user/captcha',
        method: 'post',
        responseType: "blob",
        data
    })
}

